import { FC } from 'react';

import Image from './image.png';

export const ServiceImage: FC = () => <img src={Image} alt="service" />;
